import { Component, computed, input } from '@angular/core';
import { AvatarSize } from '../avatar.types';

@Component({
  selector: 'ntt-avatar-verified-icon',
  template: `
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 10" fill="none">
      <path
        class="verified-badge"
        d="M7.33412 1.38292C7.4291 1.61262 7.6114 1.7952 7.84095 1.89052L8.64588 2.22393C8.8756 2.31908 9.05811 2.50159 9.15326 2.7313C9.24841 2.96101 9.24841 3.21912 9.15326 3.44883L8.82008 4.25318C8.72489 4.483 8.72476 4.74137 8.82038 4.97107L9.15298 5.77518C9.20015 5.88896 9.22444 6.01091 9.22446 6.13408C9.22448 6.25724 9.20023 6.3792 9.15309 6.49299C9.10596 6.60678 9.03687 6.71017 8.94976 6.79725C8.86266 6.88432 8.75925 6.95338 8.64545 7.00048L7.84109 7.33365C7.6114 7.42863 7.42882 7.61093 7.3335 7.84048L7.00008 8.64542C6.90493 8.87513 6.72243 9.05764 6.49271 9.15279C6.263 9.24794 6.0049 9.24794 5.77518 9.15279L4.97083 8.81961C4.74111 8.7247 4.4831 8.72489 4.25352 8.82015L3.44859 9.15309C3.219 9.24802 2.96113 9.24794 2.7316 9.15286C2.50207 9.05779 2.31967 8.8755 2.22445 8.64603L1.89094 7.84086C1.79596 7.61117 1.61366 7.42859 1.38411 7.33327L0.579176 6.99985C0.349563 6.90474 0.16711 6.72235 0.0719244 6.49277C-0.0232613 6.26319 -0.0233905 6.00521 0.0715655 5.77553L0.404739 4.97118C0.499656 4.74146 0.499462 4.48344 0.4042 4.25387L0.0715048 3.44836C0.0243352 3.33459 4.68207e-05 3.21263 2.70994e-05 3.08947C7.19046e-06 2.9663 0.0242565 2.84434 0.0713898 2.73055C0.118523 2.61676 0.187616 2.51337 0.27472 2.4263C0.361825 2.33922 0.465234 2.27016 0.579039 2.22306L1.38339 1.88989C1.61289 1.795 1.79536 1.61293 1.89075 1.38364L2.22416 0.578707C2.31931 0.348993 2.50182 0.166486 2.73153 0.0713353C2.96124 -0.0238153 3.21935 -0.0238153 3.44906 0.0713353L4.25342 0.404509C4.48314 0.499425 4.74115 0.499232 4.97072 0.40397L5.77599 0.071852C6.00567 -0.0232452 6.26372 -0.0232258 6.49339 0.071906C6.72306 0.167038 6.90554 0.349492 7.00071 0.579146L7.33422 1.38432L7.33412 1.38292Z"
      />
      <path
        class="verified-check"
        d="M6.5 3.75L4.375 5.875L3.5 5"
        stroke-width="1"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  `,
  host: {
    '[class]': 'classes()',
  },
  styles: `
    :host {
      display: block;
      position: absolute;
      overflow: hidden;
      --ntt-avatar-verified-badge: var(--utility-blue-500, #2970ff);
      --ntt-avatar-verified-check: var(--fg-white, white);
    }

    svg {
      display: block;
      width: 100%;
      height: 100%;
    }

    .verified-badge {
      fill: var(--ntt-avatar-verified-badge);
    }

    .verified-check {
      stroke: var(--ntt-avatar-verified-check);
    }

    :host(.ntt-avatar-verified--xs) {
      width: 10px;
      height: 10px;
      bottom: 0;
      right: 0;
    }

    :host(.ntt-avatar-verified--sm) {
      width: 12px;
      height: 12px;
      bottom: 0;
      right: 0;
    }

    :host(.ntt-avatar-verified--md) {
      width: 14px;
      height: 14px;
      bottom: 0;
      right: 0;
    }

    :host(.ntt-avatar-verified--lg) {
      width: 16px;
      height: 16px;
      bottom: 0;
      right: 0;
    }

    :host(.ntt-avatar-verified--xl) {
      width: 18px;
      height: 18px;
      bottom: 0;
      right: 0;
    }

    :host(.ntt-avatar-verified--2xl) {
      width: 20px;
      height: 20px;
      bottom: 0;
      right: 0;
    }
  `,
})
export class NttAvatarVerifiedIcon {
  readonly size = input<AvatarSize>('md');

  protected readonly classes = computed(
    () => `ntt-avatar-verified ntt-avatar-verified--${this.size()}`,
  );
}
